export default __webpack_public_path__ + "static/media/login-logo.cc54ccae.svg";